
/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import {map, distinctUntilChanged, debounceTime, startWith} from 'rxjs/operators';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { User, StakeholderGroup } from '../../lib/wwg.classes';
import { UserApi } from '../../sdk/services/custom';
import { NotificationService } from '../../services/notification.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'wwg-stakeholder-group',
  templateUrl: './stakeholder-group.component.html',
  styleUrls: ['./stakeholder-group.component.scss']
})
export class StakeholderGroupComponent implements OnInit {

  public users: User[];
  public stakeholderCtrl = new FormControl();
  public verifierCtrl = new FormControl();
  public escalationCtrl = new FormControl();
  public stakeholderFilter: Observable<User[]>;
  public verifiedFilter: Observable<User[]>;
  public escalationFilter: Observable<User[]>;

  public _model = new StakeholderGroup();
  @Input() get model() {
    return this._model;
  }
  @Input() public requiredStakeholder: boolean = false;
  @Input() public requiredVerifier: boolean = false;
  @Input() public requiredEscalation: boolean = false;

  @Output() modelChange = new EventEmitter();

  constructor(
    private userApi: UserApi,
    private notificationService: NotificationService) {

    this.stakeholderFilter = this.stakeholderCtrl.valueChanges.pipe(
      startWith(null),
      debounceTime(200),
      distinctUntilChanged(),
      map(val => this.filterUser(val, this.model.stakeholder)),);

    this.verifiedFilter = this.verifierCtrl.valueChanges.pipe(
      startWith(null),
      debounceTime(200),
      distinctUntilChanged(),
      map(val => this.filterUser(val, this.model.verifier)),);

    this.escalationFilter = this.escalationCtrl.valueChanges.pipe(
      startWith(null),
      debounceTime(200),
      distinctUntilChanged(),
      map(val => this.filterUser(val, this.model.escalation)),);
  }

  set model(val) {
    this._model = val;
    this.modelChange.emit(this._model);
  }

  ngOnInit() {
    this.userApi.list().toPromise().then((resp) => {
      this.users = resp.data;
    }).catch(this.notificationService.errorHandler);
  }

  filterUser(val, currentUsers: string[]) {
    if (!val) {
      return this.users.filter(u => !currentUsers.includes(u._id));
    }

    return this.searchUser(val).filter(u => !currentUsers.includes(u._id));
  }

  private searchUser(val) {
    return this.users.filter((user) => {
      const regex = new RegExp(`${val}`, 'gi');
      return regex.test(user.firstName) || regex.test(user.surname) || regex.test(user.email);
    });
  }

  displayUser(userId: string) {
    if (!userId) {
      return '';
    }
    const user = this.users.find(u => u._id === userId);
    if (!user) {
      return 'Look up failed';
    }

    return user.firstName ? `${user.firstName} ${user.surname}` : user._id;
  }

  renderUserTooltip = (userId: string) => {
    if (!userId) {
      return '';
    }
    const user = this.users.find(u => u._id === userId);
    if (!user) {
      return 'Look up failed ' + userId;
    }

    return `${user.email} ${user._id}`;
  }

  addUserToList(verifier: string[], user: User, ctrl: FormControl) {
    if (verifier.includes(user._id)) {
      return;
    }
    verifier.push(user._id);
    ctrl.setValue('');
  }

  public addStakeholderGroup() {
    if (!this.model) {
      this.model = new StakeholderGroup();
    }
  }
}
